 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"index": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"index": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"playground":"playground"}[chunkId]||chunkId) + "." + {"chunk-120df662":"ebc3bf80","chunk-2cfdb2f8":"d52cbbba","chunk-2d0aad34":"01f98012","chunk-2d0b2e8a":"2dc0e906","chunk-2d0d6ab9":"16844153","chunk-2deaf066":"d757406b","chunk-2e2cd334":"7428c446","chunk-34bd68e0":"dc2e296a","chunk-34bfc00e":"8290235c","chunk-42d27f5e":"8aaa8ebe","chunk-4c055398":"eb237da1","chunk-5bdb654c":"9637677c","chunk-74ef5975":"b416fd6e","chunk-9ba8232a":"7b235ec0","chunk-ad4ddaee":"652e3fd9","chunk-bd14e4c4":"69d9a012","chunk-c3b2ce2a":"770dea0e","chunk-f7fab246":"b5a5cd5a","chunk-fbdde770":"ec0caa62","playground":"06dbd351","chunk-17da4558":"91ed6f52","chunk-2d2172f9":"2159b5b2","chunk-2d224b30":"82e29dce","chunk-abbd0998":"606a5188","chunk-2d0e9387":"96df5951","chunk-2d21eec8":"37a452fc","chunk-217a3fe5":"a846ddcf","chunk-2d225f6c":"c787b497","chunk-65e8ee2c":"c626315b","chunk-7235ff3f":"6cca5a3a","chunk-2d0dec98":"58591bfc","chunk-2d2077d4":"1a49c5d3","chunk-2d20fb38":"fd316ea4","chunk-029eb793":"37f98560","chunk-13def3e0":"e6b678ab","chunk-21501f99":"4a5baac3","chunk-2d212f6a":"e5927620","chunk-2d22c161":"2f63e4e9","chunk-2d0cc43a":"43cd26b3","chunk-2d0b9219":"70576531","chunk-2d21774a":"0c4c8163","chunk-39f14685":"34ecd559","chunk-2d230844":"cd65bac7","chunk-2d212b86":"c7f59bc2","chunk-2d0e9b16":"fc39d3af","chunk-a1e69172":"67f72df4","chunk-2d0b6afa":"e8528db1","chunk-62a610d0":"e9745d39","chunk-2d0e9214":"29e433ba","chunk-2d213b26":"fc365394"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-120df662":1,"chunk-4c055398":1,"chunk-ad4ddaee":1,"chunk-c3b2ce2a":1,"chunk-17da4558":1,"chunk-abbd0998":1,"chunk-217a3fe5":1,"chunk-7235ff3f":1,"chunk-029eb793":1,"chunk-39f14685":1,"chunk-a1e69172":1,"chunk-62a610d0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"playground":"playground"}[chunkId]||chunkId) + "." + {"chunk-120df662":"c6b8fc83","chunk-2cfdb2f8":"31d6cfe0","chunk-2d0aad34":"31d6cfe0","chunk-2d0b2e8a":"31d6cfe0","chunk-2d0d6ab9":"31d6cfe0","chunk-2deaf066":"31d6cfe0","chunk-2e2cd334":"31d6cfe0","chunk-34bd68e0":"31d6cfe0","chunk-34bfc00e":"31d6cfe0","chunk-42d27f5e":"31d6cfe0","chunk-4c055398":"37ac798e","chunk-5bdb654c":"31d6cfe0","chunk-74ef5975":"31d6cfe0","chunk-9ba8232a":"31d6cfe0","chunk-ad4ddaee":"6d23e3c3","chunk-bd14e4c4":"31d6cfe0","chunk-c3b2ce2a":"71d91fb1","chunk-f7fab246":"31d6cfe0","chunk-fbdde770":"31d6cfe0","playground":"31d6cfe0","chunk-17da4558":"6d23e3c3","chunk-2d2172f9":"31d6cfe0","chunk-2d224b30":"31d6cfe0","chunk-abbd0998":"a786e434","chunk-2d0e9387":"31d6cfe0","chunk-2d21eec8":"31d6cfe0","chunk-217a3fe5":"f741d88f","chunk-2d225f6c":"31d6cfe0","chunk-65e8ee2c":"31d6cfe0","chunk-7235ff3f":"bd0df0ce","chunk-2d0dec98":"31d6cfe0","chunk-2d2077d4":"31d6cfe0","chunk-2d20fb38":"31d6cfe0","chunk-029eb793":"26511152","chunk-13def3e0":"31d6cfe0","chunk-21501f99":"31d6cfe0","chunk-2d212f6a":"31d6cfe0","chunk-2d22c161":"31d6cfe0","chunk-2d0cc43a":"31d6cfe0","chunk-2d0b9219":"31d6cfe0","chunk-2d21774a":"31d6cfe0","chunk-39f14685":"614f0e66","chunk-2d230844":"31d6cfe0","chunk-2d212b86":"31d6cfe0","chunk-2d0e9b16":"31d6cfe0","chunk-a1e69172":"cda62268","chunk-2d0b6afa":"31d6cfe0","chunk-62a610d0":"6d23e3c3","chunk-2d0e9214":"31d6cfe0","chunk-2d213b26":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
